import axios from 'services/axios'
import trim from 'lodash/trim'
import { API_SEND_OTP, API_VERIFY_OTP } from 'constants/endpoints'

/**
 * Send OTP
 *
 * @param {Boolean} isResend
 * @return {Object}
 */
export const sendOTP = async (isResend = false) => {
  try {
    const { code, message, data } = await axios.post(API_SEND_OTP, {
      method: 'email',
      isResend,
    })

    if (code === 'A200') {
      return data
    }

    throw message
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Verify OTP
 *
 * @param {Object} form
 * @return {Object}
 */
export const verifyOTP = async (form) => {
  try {
    const { code, data } = await axios.post(API_VERIFY_OTP, {
      ...form,
      otp: trim(form.otp),
    })

    if (code === 'A200') {
      return data
    }

    throw data
  } catch (error) {
    return Promise.reject(error)
  }
}
